import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext, AuthProvider } from './context/AuthContext';
import Shiba from './pages/Shiba';
import Dart from './pages/Dart';
import SubjectShiba from './pages/SubjectShiba';
import SubjectDart from './pages/SubjectDart';
import NotFoundPage from './pages/NotFoundPage'; // 404 ページ（必要なら作る）
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import UserPage from './pages/UserPage';
import Previous from './pages/Previous';
import Yosou from './pages/Yosou';
import YosouRegist from './pages/YosouRegist';
import RaceList from './pages/RaceList';
import OldRaceList from './pages/OldModelRaceList';
import NewRaceList from './pages/NewModelRaceList';
import ChiririModelRaceList from './pages/ChiririModelRaceList';
import NarModelRaceList from './pages/NarModelRaceList';
import KeirinModelRaceList from './pages/KeirinModelRaceList';
import ChiririModelKaimePage from './pages/ChiririModelKaimePage';
import LpPage from './pages/LpPage';
import NotePostsPage from './pages/NotePostsPage';
import PlanSelectPage from './pages/PlanSelectPage';
import MyPage from './pages/MyPage';
import BillingCallbackPage from './pages/BillingCallbackPage';
import TokushohoPage from './pages/legal/TokushohoPage';
import TermsPage from './pages/legal/TermsPage';
import PrivacyPage from './pages/legal/PrivacyPage';
// **認証が必要なページ（未ログイン時は `/login` にリダイレクト）**
// `requiredPermission="admin"` を渡すと管理者以外を弾く。以前は受け取るだけで
// 使っておらず、/user が全ログインユーザーに開いていた（API 側は 403 を返す）。
const PrivateRoute = ({ element, requiredPermission }) => {
  const { isAuthenticated, adminValid } = useContext(AuthContext);

  if (isAuthenticated === null) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // 画面の出し分けにすぎない。認可の正はサーバの require_admin（ADMIN_EMAILS）。
  if (requiredPermission === 'admin' && !adminValid) {
    return <Navigate to="/chiriri_model_race_list" replace />;
  }

  return element;
};
// **ログインページへのアクセス制御（ログイン済みならレース一覧へ）**
const PublicRoute = ({ element }) => {
  const { isAuthenticated } = useContext(AuthContext);
  return isAuthenticated ? <Navigate to="/chiriri_model_race_list" replace /> : element;
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<PublicRoute element={<LoginPage />} />} />
          <Route path="/signup" element={<PublicRoute element={<SignupPage />} />} />
          {/* 一般公開前の秘密URL。既存のブックマークを切らさないため残す（#31 残タスク3） */}
          <Route path="/usersignupsecret" element={<Navigate to="/signup" replace />} />
          <Route path="/lp" element={<LpPage />} />
          {/* 法務ページ。申込前・未ログインでも読めなければならないため /lp と同じく公開にする */}
          <Route path="/tokushoho" element={<TokushohoPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          {/* <Route element={<Layout />}> */}
          {/* 未ログインでも無料枠を見せるので、入口でログインを要求しない（#36） */}
          <Route path="/" element={<Navigate to="/chiriri_model_race_list" replace />} />
          <Route path="/plan" element={<PlanSelectPage />} />
          <Route path="/billing/callback" element={<BillingCallbackPage />} />
          <Route path="/mypage" element={<PrivateRoute element={<MyPage />} />} />
          {/* <Route path="/user" element={<PrivateRoute element={<UserPage />} requiredPermission="admin"/>} /> */}
          <Route
            path="/user"
            element={<PrivateRoute element={<UserPage />} requiredPermission="admin" />}
          />
          <Route path="/subject_shiba" element={<PrivateRoute element={<SubjectShiba />} />} />
          <Route path="/subject_all" element={<PrivateRoute element={<SubjectDart />} />} />
          <Route path="/shiba" element={<PrivateRoute element={<Shiba />} />} />
          <Route path="/dart" element={<PrivateRoute element={<Dart />} />} />
          <Route path="/yosou" element={<PrivateRoute element={<Yosou />} />} />
          <Route path="/previous" element={<PrivateRoute element={<Previous />} />} />
          <Route path="/yosou_regist" element={<PrivateRoute element={<YosouRegist />} />} />
          <Route path="/race_list" element={<PrivateRoute element={<RaceList />} />} />
          <Route path="/old_model_race_list" element={<PrivateRoute element={<OldRaceList />} />} />
          <Route path="/new_model_race_list" element={<PrivateRoute element={<NewRaceList />} />} />
          {/* 販売対象の3コンテンツは未ログインでも開く。無料枠1レースだけが見え、
              残りはロック表示になる（マスクはサーバ側 #34 が行う / #36） */}
          <Route path="/chiriri_model_race_list" element={<ChiririModelRaceList />} />
          {/* 中央新版は中央競馬に一本化した（#270）。中身は /chiriri_model_race_list と同じなので転送する */}
          <Route path="/new_ana_model_race_list" element={<Navigate to="/chiriri_model_race_list" replace />} />
          {/* 旧 ana（csv_v14）は ana_new とは別モデルで生成も停止済み（#125）。
              行き先を変えると中身が変わるので、クローズ時のまま中央競馬へ送る */}
          <Route path="/ana_model_race_list" element={<Navigate to="/chiriri_model_race_list" replace />} />
          {/* 2026-08-11 のクローズ以前に配られた旧URL。ブックマーク救済として送る（#270 以降は中央競馬へ） */}
          <Route path="/ana_new_model_race_list" element={<Navigate to="/chiriri_model_race_list" replace />} />
          {/* 厳選1点（TOP1）は公開ページをクローズ。裏のペーパーフォワード検証は継続 */}
          <Route path="/top1_model_race_list" element={<Navigate to="/chiriri_model_race_list" replace />} />
          <Route path="/nar_model_race_list" element={<NarModelRaceList />} />
          <Route path="/keirin_model_race_list" element={<KeirinModelRaceList />} />
          <Route path="/note_posts" element={<PrivateRoute element={<NotePostsPage />} />} />
          <Route path="/chiriri_model_kaime_test" element={<PrivateRoute element={<ChiririModelKaimePage />} />} />
          {/* #278: 未ログインで開けるのに契約者限定の API を呼んでいた。アクセスが無いため廃止 */}
          <Route path="/youtube_race" element={<Navigate to="/chiriri_model_race_list" replace />} />
          <Route path="*" element={<NotFoundPage />} /> {/* 404 ページ */}
          {/* </Route> */}
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
